<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Offices">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Offices">Offices</b-breadcrumb-item>
            <b-breadcrumb-item active>Add</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Create New Office</div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2 form-group">
                            <label for="isTTIOffice">Maintained by TTI</label>
                            <b-form-checkbox
                                v-model="isTTIOffice"
                            ></b-form-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-12 form-group">
                            <label for="buildingName">Office Name</label>
                            <input :class="{'is-invalid': $v.name.$invalid}" autocomplete="off"
                                   class="form-control"
                                   maxlength="70"
                                   placeholder="Office Name"
                                   v-model.lazy="name"/>
                            <span class="invalid-feedback" v-if="!$v.name.required">Field is required</span>
                            <span class="invalid-feedback" v-if="!$v.name.isUnique">The building name is already in use</span>
                            <span class="invalid-feedback" v-if="!$v.name.maxLength">Name must be &le; 70 characters</span>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 form-group">
                            <label for="shortName">Office Short Name</label>
                            <input :class="{'is-invalid': $v.shortName.$invalid}" class="form-control"
                                   maxlength="15"
                                   placeholder="Office Short Name" v-model="shortName"/>
                            <span class="invalid-feedback" v-if="!$v.shortName.maxLength">Short name must be &le; 15 characters</span>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 form-group">
                            <label for="code">TAMU Building Code</label>
                            <input :class="{'is-invalid': $v.code.$invalid}" class="form-control"
                                   maxlength="15"
                                   placeholder="TAMU Building Code" v-model.lazy="code"/>
                            <span class="invalid-feedback" v-if="!$v.code.required">Field is required</span>
                            <span class="invalid-feedback" v-if="!$v.code.isUnique">The building code is already in use</span>
                            <span class="invalid-feedback" v-if="!$v.code.maxLength">Code must be &le; 15 characters</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 form-group">
                            <label for="address">Address</label>
                            <input :class="{'is-invalid': $v.address.$invalid}" class="form-control"
                                   maxlength="100"
                                   placeholder="Address" v-model="address"/>
                            <span class="invalid-feedback" v-if="!$v.address.required">Field is required</span>
                            <span class="invalid-feedback" v-if="!$v.address.maxLength">Address must be &le; 100 characters</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 col-lg-4 form-group">
                            <label for="City">City</label>
                            <input :class="{'is-invalid': $v.city.$invalid}" class="form-control"
                                   maxlength="50"
                                   placeholder="City" v-model="city"/>
                            <span class="invalid-feedback" v-if="!$v.city.required">Field is required</span>
                            <span class="invalid-feedback" v-if="!$v.city.maxLength">City must be &le; 50 characters</span>
                        </div>

                        <div class="col-md-3 col-lg-4 form-group">
                            <label for="City">State</label>
                            <AppSelectState v-model="stateCode"/>
                        </div>

                        <div class="col-md-3 col-lg-4  form-group">
                            <label for="zipCode">Zip Code</label>
                            <input :class="{'is-invalid': $v.zipCode.$invalid}" class="form-control"
                                   maxlength="12"
                                   placeholder="Zip Code" v-model="zipCode"/>
                            <span class="invalid-feedback" v-if="!$v.zipCode.required">Field is required</span>
                            <span class="invalid-feedback" v-if="!$v.zipCode.maxLength">Zip code must be &le; 12 characters</span>
                        </div>

                        <div class="col-md-3 col-lg-4  form-group">
                            <label for="mailStop">Mail Stop</label>
                            <input :class="{'is-invalid': $v.mailStop.$invalid}" class="form-control"
                                   maxlength="15"
                                   placeholder="Mail Stop" v-model="mailStop"/>
                            <span class="invalid-feedback" v-if="!$v.city.maxLength">Mail stop must be &le; 15 characters</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'Buildings'}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import {maxLength, required} from "vuelidate/lib/validators";
    import AppSelectState from "@/components/shared/AppSelectState";
    import AddressService from "@/services/AddressService";

    export default {
        components: {
            AppSelectState
        },
        data() {
            return {
                name: null,
                code: null,
                shortName: null,
                city: null,
                stateCode: null,
                zipCode: null,
                mailStop: null,
                address: null,
                isTTIOffice: false,
                isSubmitting: false,
            }
        },
        methods: {
            /**
             * @description Creates a building and redirects if successful
             */
            onSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                AddressService.addBuilding({
                    name: this.name,
                    code: this.code,
                    shortName: this.shortName,
                    city: this.city,
                    stateCode: this.stateCode,
                    zipCode: this.zipCode,
                    mailStop: this.mailStop,
                    address: this.address,
                    isTTIOffice: this.isTTIOffice
                }).then(() => {
                    vm.alert(ToastType.Success, `The building '${vm.name}' was successfully created.`);

                    // Redirect to the buildings page
                    vm.$router.replace({name: 'Buildings'})
                }).catch(function (error) {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            }
        },
        validations: {
            name: {
                required,
                maxLength: maxLength(70),
                isUnique(value) {
                    if (!value) return true;

                    return AddressService.getBuildingList({
                        page: 1,
                        pageSize: 1,
                        name: value
                    }).then(response => response.totalCount === 0)
                        .catch(() => {
                            return true;
                        })
                }
            },
            shortName: {
                maxLength: maxLength(15)
            },
            code: {
                required,
                maxLength: maxLength(15),
                isUnique(value) {
                    if (!value) return true;

                    return AddressService.getBuildingList({
                        page: 1,
                        pageSize: 1,
                        code: value
                    }).then(response => response.totalCount === 0)
                        .catch(() => {
                            return true;
                        })
                }
            },
            address: {
                required,
                maxLength: maxLength(100)
            },
            city: {
                required,
                maxLength: maxLength(50)
            },
            zipCode: {
                required,
                maxLength: maxLength(12)
            },
            mailStop: {
                maxLength: maxLength(15)
            }
        }
    }
</script>
